import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/DraftOrder/Suppliers'

export default createChildListViewContainer()(Component)
